export const removeScript = (id: string) => {
  const element = document.getElementById(id);
  if (!!element) {
    document.head.removeChild(element);
  }
};

export default removeScript;
